/**
 * Contact / demo-request dialog (Figma 232:4).
 * Self-contained: initContactDialog() wires openers, closing, and Web3Forms submit.
 * Kept framework-free so a future React migration can lift the logic as-is.
 */

const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit';

export function initContactDialog(): void {
  const dialog = document.querySelector<HTMLDialogElement>('.contact-dialog');
  const successDialog = document.querySelector<HTMLDialogElement>('.success-dialog');
  if (!dialog) return;

  const form = dialog.querySelector('form');
  const status = dialog.querySelector<HTMLElement>('.contact-dialog__status');
  const submit = dialog.querySelector<HTMLButtonElement>('.contact-dialog__submit');
  if (!form || !status || !submit) return;

  for (const opener of document.querySelectorAll<HTMLElement>('[data-dialog-open]')) {
    opener.addEventListener('click', (event) => {
      event.preventDefault();
      dialog.showModal();
    });
  }

  dialog.querySelector('.contact-dialog__close')?.addEventListener('click', () => dialog.close());

  // click on the backdrop (outside the card) closes
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  if (successDialog) {
    for (const sel of ['.success-dialog__close', '.success-dialog__ok']) {
      successDialog.querySelector(sel)?.addEventListener('click', () => successDialog.close());
    }
    successDialog.addEventListener('click', (event) => {
      if (event.target === successDialog) successDialog.close();
    });
  }

  const showStatus = (kind: 'error', message: string) => {
    status.textContent = message;
    status.classList.toggle('is-error', kind === 'error');
    status.hidden = false;
  };

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    void (async () => {
      status.hidden = true;
      submit.disabled = true;
      const label = submit.querySelector('span');
      const idleText = label?.textContent ?? '';
      if (label) label.textContent = 'Submitting…';
      try {
        const response = await fetch(WEB3FORMS_ENDPOINT, {
          method: 'POST',
          body: new FormData(form),
        });
        const result: { success?: boolean; message?: string } = await response.json();
        if (result.success) {
          form.reset();
          dialog.close();
          successDialog?.showModal();
        } else {
          showStatus('error', result.message ?? 'Something went wrong. Please try again.');
        }
      } catch {
        showStatus('error', 'Network error. Please try again.');
      } finally {
        submit.disabled = false;
        if (label) label.textContent = idleText;
      }
    })();
  });
}
